export default {
  default: [
    {
      name: 'Product',
      items: [
        { title: 'How it works', url: '/how-it-works' },
        { title: 'Features', url: '/features' },
        { title: 'Integrations', url: '/integrations' },
        { title: 'Enterprise', url: '/enterprise' },
        { title: 'Pricing', url: '/pricing' }
      ],
    },
    {
      name: 'Creatives',
      items: [
        { title: 'For Creatives', url: '/creatives' },
        { title: 'Join BOOM', url: '/join-boom' },
        { title: 'FAQs', url: '/creatives/faq' }
      ],
    },
    {
      name: 'Company',
      items: [
        { title: 'About', url: '/about-us' },
        { title: 'Manifesto', url: '/manifesto' },
        { title: 'Impact', url: '/social-impact' },
        { title: 'Press', url: '/press' },
        { title: 'Careers', url: '/careers' },
        { title: 'Contact', url: '/contact' },
        { title: 'Customers', url: '/customer-stories' },
      ],
    },
    {
      name: 'Resources',
      items: [
        { title: 'Help Center', url: 'https://help.boom.co/372708-Help-Center' },
        { title: 'Articles', url: '/resources/articles' },
        { title: 'Webinars', url: '/resources/webinars' },
        { title: 'Events', url: '/resources/events' },
        { title: 'eBooks', url: '/resources/ebooks' },
        // { title: 'API Reference', url: '/resources/api-reference' },
        // { title: 'Documentation', url: '/resources/documentation' },
      ],
    },
    {
      name: 'Use Cases',
      items: [
        { title: 'Food Delivery', url: '/food-delivery' },
        { title: 'Real Estate', url: '/real-estate' },
        { title: 'Short-Term Rental', url: '/short-term-rental' },
        { title: 'Product', url: '/factory' },
        { title: 'Fashion & Luxury', url: '/factory' },
      ],
    },
    {
      name: 'Contact',
      items: [{ title: 'Contact', url: '/contact' }],
      socialIcons: true,
    },
  ],

  it: [
    {
      name: 'Prodotto',
      items: [
        { title: 'Come funziona', url: '/it/come-funziona/' },
        { title: 'Funzionalità', url: '/it/funzionalita/' },
        { title: 'Integrazioni', url: '/it/integrazioni/' },
        { title: 'Enterprise', url: '/it/enterprise' },
        { title: 'Prezzi', url: '/it/prezzi/' },
      ],
    },
    {
      name: 'Creativi',
      items: [
        { title: 'Per i creativi', url: '/it/fotografi/' },
        { title: 'Unisciti a BOOM', url: '/it/join-boom/' },
        { title: 'FAQs', url: '/it/fotografi/faq' },
        // { title: 'Restaurant Owners FAQs', url: '/it/faqs/restaurants-food-business/' },
        // { title: 'Property Owners FAQs', url: '/it/faqs/property-owners/' },
      ],
    },
    {
      name: 'Azienda',
      items: [
        { title: 'Chi siamo', url: '/it/chi-siamo/' },
        { title: 'Il nostro manifesto', url: '/it/manifesto/' },
        { title: 'Impatto', url: '/it/social-impact/' },
        { title: 'Stampa', url: '/it/stampa/' },
        { title: 'Posizioni aperte', url: '/it/carriere/' },

        { title: 'Contatti', url: '/it/contatti/' },
        { title: 'Clienti', url: '/it/customer-stories/' },
      ],
    },
    {
      name: 'Risorse',
      items: [
        { title: 'Centro assistenza', url: 'https://help.boom.co/372708-Help-Center' },
        { title: 'Articoli', url: '/it/resources/articles' },
        { title: 'Webinars', url: '/it/resources/webinars' },
        { title: 'Eventi', url: '/it/resources/events' },
        { title: 'eBooks', url: '/it/resources/ebooks' },
        // { title: 'Riferimento API', url: '/it/resources/api-reference' },
        // { title: 'Documentazione', url: '/it/resources/documentation' },
      ],
    },
    {
      name: 'CASI D\'USO',
      items: [
        { title: 'Food delivery', url: '/it/food-delivery/' },
        { title: 'Immobiliare', url: '/it/immobiliare/' },
        { title: 'Affitti a breve termine', url: '/it/affitto-breve-termine/' },
        { title: 'Prodotto', url: '/it/factory' },
        { title: 'Moda e lusso', url: '/it/factory' },
      ],
    },
    {
      name: 'CONTATTI',
      items: [{ title: 'Contatti', url: '/it/contatti/' }],
      socialIcons: true,
    },
  ],

  fr: [
    {
      name: 'Produit',
      items: [
        { title: 'Comment ça marche', url: '/fr/comment-cela-fonctionne' },
        { title: 'Caractéristiques', url: '/fr/fonctionnalites' },
        { title: 'Intégrations', url: '/fr/integrations' },
        { title: 'Entreprise', url: '/fr/enterprise' },
        { title: 'Tarifs', url: '/fr/prix' }
      ],
    },
    {
      name: 'Créatifs',
      items: [
        { title: 'Pour les créatifs', url: '/fr/photographe-professionnel' },
        { title: 'Rejoignez BOOM', url: '/fr/join-boom' },
        // { title: 'Restaurant Owners FAQs', url: '/fr/faqs/restaurants-food-business' },
        // { title: 'Property Owners FAQs', url: '/fr/faqs/property-owners' },
        { title: 'FAQs', url: '/fr/photographe-professionnel/faq' },
      ],
    },
    {
      name: 'Entreprise',
      items: [
        { title: 'À propos de nous', url: '/fr/qui-nous-sommes' },
        { title: 'Notre Manifeste', url: '/fr/manifesto' },
        { title: 'Impact', url: '/fr/social-impact' },
        { title: 'Presse', url: '/fr/press' },
        { title: 'Carrières', url: '/fr/carriere' },
        { title: 'Contact', url: '/fr/contact' },
        { title: 'Clients', url: '/fr/customer-stories' },
      ],
    },
    {
      name: 'Ressources',
      items: [
        { title: 'Centre d\'aide', url: 'https://help.boom.co/372708-Help-Center' },
        { title: 'Articles', url: '/fr/resources/articles' },
        { title: 'Webinaires', url: '/fr/resources/webinars' },
        { title: 'Événements', url: '/fr/resources/events' },
        { title: 'Livre Blanc', url: '/fr/resources/ebooks' },

        // { title: 'Référence API', url: '/fr/resources/api-reference' },
        // { title: 'Documentation', url: '/fr/resources/documentation' },
      ],
    },
    {
      name: 'CAS D\'UTILISATION',
      items: [
        { title: 'Livraison de repas', url: '/fr/livraison-de-repas' },
        { title: 'Immobilier', url: '/fr/immobilier' },
        { title: 'Location courte durée', url: '/fr/locations-courte-duree' },
        { title: 'Produit', url: '/fr/factory' },
        { title: 'Mode et luxe', url: '/fr/factory' },
      ],
    },
    {
      name: 'Contact',
      items: [{ title: 'Contact', url: '/fr/contact' }],
      socialIcons: true,
    },
  ],

  es: [
    {
      name: 'Producto',
      items: [
        { title: 'Cómo funciona', url: '/es/como-funciona' },
        { title: 'Prestaciones', url: '/es/funcionalidades' },
        { title: 'Integraciones', url: '/es/integraciones' },
        { title: 'Enterprise', url: '/es/enterprise' },
        { title: 'Precios', url: '/es/precios' }
      ],
    },
    {
      name: 'Creativos',
      items: [
        { title: 'Para creativos', url: '/es/fotografos' },
        { title: 'Únete a BOOM', url: '/es/join-boom' },
        // { title: 'Restaurant Owners FAQs', url: '/es/faqs/restaurants-food-business' },
        // { title: 'Property Owners FAQs', url: '/es/faqs/property-owners' },
        { title: 'Preguntas frecuentes', url: '/es/fotografos/preguntas-frecuentes' },
      ],
    },
    {
      name: 'Empresa',
      items: [
        { title: 'Sobre nosotros', url: '/es/sobre-nosotros' },
        { title: 'Nuestro manifiesto', url: '/es/manifesto' },
        { title: 'Impacto', url: '/es/social-impact' },
        { title: 'Prensa', url: '/es/prensa' },
        { title: 'Empleos', url: '/es/carreras' },
        { title: 'Contacto', url: '/es/contacte' },
        { title: 'Clientes', url: '/es/customer-stories' },
      ],
    },
    {
      name: 'Recursos',
      items: [
        { title: 'Centro de Ayuda', url: 'https://help.boom.co/372708-Help-Center' },
        { title: 'Artículos', url: '/es/resources/articles' },
        { title: 'Seminarios web', url: '/es/resources/webinars' },
        { title: 'Eventos', url: '/es/resources/events' },
        { title: 'Descargas', url: '/es/resources/ebooks' },
        // { title: 'Referencia de la API', url: '/es/resources/api-reference' },
        // { title: 'Documentación', url: '/es/resources/documentation' },
      ],
    },
    {
      name: 'EJEMPLOS DE USO',
      items: [
        { title: 'Comida a domicilio', url: '/es/entrega-de-alimentos' },
        { title: 'Inmobiliarias', url: '/es/immobiliaria' },
        { title: 'Alquileres a corto plazo', url: '/es/alquiler-de-corta-duracion' },
        { title: 'Producto', url: '/es/factory' },
        { title: 'Moda y lujo', url: '/es/factory' },
      ],
    },
    {
      name: 'Contact',
      items: [{ title: 'Contacto', url: '/es/contacte' }],
      socialIcons: true,
    },
  ],

};
